const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Editorial%20collage%20style%20composition%20of%20entertainment%20news%20headlines%20and%20celebrity%20silhouettes%20with%20warm%20golden%20and%20deep%20coral%20accents%2C%20abstract%20geometric%20overlays%20on%20dark%20background%2C%20premium%20magazine%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20editorial%20design&width=1200&height=720&seq=carousel-topic-01&orientation=landscape',
    tag: '专题',
    title: '2026上半年娱乐圈大事件回顾',
    desc: '从年初的颁奖礼风波到年中的综艺大洗牌，带你回顾这半年来娱乐圈最值得铭记的每一个瞬间。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20abstract%20composition%20with%20circuit%20board%20patterns%20and%20business%20icons%20in%20warm%20amber%20tones%20on%20dark%20background%2C%20geometric%20data%20visualization%20elements%2C%20corporate%20intelligence%20aesthetic%2C%20sophisticated%20minimal%20style&width=1200&height=720&seq=carousel-topic-02&orientation=landscape',
    tag: '专题',
    title: '科技圈那些不为人知的商业暗战',
    desc: '巨头们的明争暗斗远比你想象的精彩，揭开科技圈背后的资本博弈与权力游戏。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=World%20map%20abstract%20geometric%20design%20with%20warm%20golden%20and%20deep%20rose%20color%20palette%2C%20international%20relations%20concept%2C%20diplomatic%20flags%20abstracted%2C%20dark%20sophisticated%20background%2C%20editorial%20news%20aesthetic%2C%20dynamic%20composition&width=1200&height=720&seq=carousel-topic-03&orientation=landscape',
    tag: '专题',
    title: '国际局势深度分析系列',
    desc: '全球格局正在重塑，看懂大国博弈背后的逻辑，洞察未来世界走向。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20magnifying%20glass%20and%20document%20fragments%2C%20warm%20amber%20spotlight%20on%20dark%20background%2C%20abstract%20mystery%20noir%20aesthetic%2C%20dramatic%20shadows%20and%20golden%20highlights%2C%20editorial%20photography%20style&width=1200&height=720&seq=carousel-topic-04&orientation=landscape',
    tag: '专题',
    title: '社会热点背后的真相挖掘',
    desc: '透过现象看本质，深度调查每一条热搜事件背后不为人知的故事与真相。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Financial%20market%20abstract%20composition%20with%20rising%20charts%20and%20golden%20currency%20symbols%2C%20deep%20coral%20accent%20highlights%20on%20dark%20premium%20background%2C%20wealth%20and%20investment%20concept%2C%20sophisticated%20corporate%20aesthetic%2C%20clean%20minimal%20design&width=1200&height=720&seq=carousel-topic-05&orientation=landscape',
    tag: '专题',
    title: '财经领域年度重磅事件盘点',
    desc: '从楼市波动到股市震荡，全面梳理这一年财经领域最具影响力的重大事件。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          焦点专题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          深度策划 · 重磅呈现
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-1 rounded bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}